import { render } from "./ModalCombine.vue?vue&type=template&id=aa65ccf6"
import script from "./ModalCombine.vue?vue&type=script&lang=js"
export * from "./ModalCombine.vue?vue&type=script&lang=js"

import "./ModalCombine.vue?vue&type=style&index=0&id=aa65ccf6&lang=css"
script.render = render

export default script